// extracted by mini-css-extract-plugin
module.exports = {"companyInner":"CompanyAboutDialog_companyInner_3ZLZ0","companyImg":"CompanyAboutDialog_companyImg_3BHLw","companyTitle":"CompanyAboutDialog_companyTitle_1OObU"};